/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-underscore-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorReporter extends Component {
  constructor() {
    super();
    this.handleOnError = this.handleOnError.bind(this);
    this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);
  }

  componentDidMount() {
    window.addEventListener('error', this.handleOnError);
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentDidCatch(error, info) {
    const { addErrorToReport, publicGuid } = this.props;
    addErrorToReport(error, {
      info,
      msgType: 'MAPS-Tenant',
      collectionMethod: 'componentDidCatch',
      publicGuid: `${publicGuid}`,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.handleOnError);
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  handleOnError(err) {
    const { addErrorToReport, publicGuid } = this.props;
    const { message, filename, lineno, colno, error } = err;

    addErrorToReport(
      err,
      {
        message,
        filename,
        lineno,
        colno,
        error,
        msgType: 'MAPS-Tenant',
        collectionMethod: 'error',
        publicGuid: `${publicGuid}`,
      }
    );
  }

  handleUnhandledRejection(e) {
    const { addErrorToReport, publicGuid } = this.props;
    const { message, stack, body } = e.reason || { };
    const { browserInfo } = (e.target && e.target._satellite) || { };
    const { effectiveType } = (e.target && e.target.navigator && e.target.navigator.connection) || { };

    addErrorToReport(e, {
      message,
      stack,
      body,
      msgType: 'MAPS-Tenant',
      collectionMethod: 'unhandledrejection',
      publicGuid: `${publicGuid}`,
      effectiveType,
      browserInfo,
    });
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ErrorReporter.propTypes = {
  children: PropTypes.node,
  addErrorToReport: PropTypes.func.isRequired,
  publicGuid: PropTypes.string,
};

ErrorReporter.defaultProps = {
  children: null,
  publicGuid: null,
};
